/**
 * Home route component.
 * It renders the Main template component wrapping the Home container component.
 * @module Home
 */

import React from "react"

import HomeContainer from "features/Projects/containers/Home.container"

/**
 * Renders the Home route component.
 * This component is responsible for fetching the user's projects and displaying them.
 * @function Home
 * @returns The rendered Home component.
 */
const Home: React.FC = () => {
  return (
    <>
      <title>DATA(Q) - Projects</title>
      <HomeContainer />
    </>
  )
}

export default Home
